/* bios-portal-onboarding.js — Portal gateway + onboarding overlay (extracted from main-content.liquid)
   Depends on globals: BiosAudio, window.datamosh, sessionStorage, DOM elements.
   Extracted to stay within Shopify's 256 KB section template limit. */
/* ── Portal / Experience Gateway ──────────────────────────────────────────── */
(function () {
  var portalEl = document.getElementById('bios-portal');
  if (!portalEl) return;

  /* skip portal if already chosen this session */
  if (sessionStorage.getItem('bios_choice') === 'store') {
    var _path0 = window.location.pathname;
    if ((_path0 === '/' || _path0 === '') && _path0 !== '/pages/store') {
      window.location.href = '/pages/store';
      return;
    }
  }
  if (sessionStorage.getItem('bios_portal_choice')) {
    portalEl.style.display = 'none';
    var _root0 = document.getElementById('bios-root');
    if (_root0) _root0.classList.remove('is-pre-choice');
    document.dispatchEvent(new CustomEvent('bios:portal-done'));
    document.dispatchEvent(new CustomEvent('bios:portal-dismissed'));
    return;
  }

  var titleEl   = document.getElementById('bios-portal-title');
  var ruleEl    = document.getElementById('bios-portal-rule');
  var subEl     = document.getElementById('bios-portal-sub');
  var choicesEl = document.getElementById('bios-portal-choices');
  var biosEl    = document.getElementById('bios-portal-bios');
  var storeEl   = document.getElementById('bios-portal-store');
  var biosDesc  = document.getElementById('bios-portal-bios-desc');
  var storeDesc = document.getElementById('bios-portal-store-desc');
  var hintEl    = document.getElementById('bios-portal-hint');

  var BIOS_LINES = [
    'IMMERSIVE.  DELIBERATE.  CURATED.',
  ];
  var STORE_LINES = [
    'STANDARD.  QUICK CHECKOUT.',
  ];

  /* ── line-by-line typewriter ── */
  function typeLines(el, lines, spd) {
    el.innerHTML = '';
    el.classList.add('is-typing');
    var li = 0;
    function nextLine() {
      if (li >= lines.length) { el.classList.remove('is-typing'); return; }
      var row = document.createElement('div');
      row.className = 'bios-portal-desc-line';
      el.appendChild(row);
      var text = lines[li++];
      var ci = 0;
      (function ch() {
        if (ci < text.length) {
          row.textContent = text.slice(0, ++ci);
          setTimeout(ch, spd + Math.random() * spd * 0.35);
        } else {
          setTimeout(nextLine, 65 + Math.random() * 55);
        }
      })();
    }
    nextLine();
  }

  /* ── Touch-device portal adaptation ── */
  var portalIsTouch = (navigator.maxTouchPoints > 0) ||
                      window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  if (portalIsTouch && hintEl) {
    hintEl.textContent = '[ TAP TO ENTER ]';
  }

  /* ── Skip-animation flag for return visits ──────────────────────────
     User asked: after navigating from a subpage ([experience]/[faq]/
     [sketches]/[lab]) back to the homepage, the portal welcome
     animation replays — typewriter, sequential fade-ins, the whole
     1.6s sequence. They want it to play ONCE per session and on
     subsequent renders show the final state immediately.

     Mechanism: sessionStorage flag `bios_portal_animated`. Set after
     the first portal render completes. On subsequent renders the
     wordmark is filled instantly + all .is-vis classes are applied
     synchronously, skipping the staged setTimeouts. */
  var _portalAlreadyAnimated = false;
  try { _portalAlreadyAnimated = sessionStorage.getItem('bios_portal_animated') === '1'; } catch (_) {}

  if (_portalAlreadyAnimated) {
    /* Final-state shortcut — no fade-in delays. The portal pre-paint
       script in main-content.liquid already adds .is-visible synchronously
       so the dark gap is gone; this loop just snaps every inner
       element to its visible end-state. */
    portalEl.classList.add('is-visible');
    titleEl.classList.add('is-vis');
    if (ruleEl) ruleEl.classList.add('is-vis');
    subEl.classList.add('is-vis');
    choicesEl.classList.add('is-vis');
    hintEl.classList.add('is-vis');
  } else {
    /* First-visit-of-session: original staged fade-in. */
    setTimeout(function () { portalEl.classList.add('is-visible'); }, 80);
    setTimeout(function () { titleEl.classList.add('is-vis');      }, 120);
    if (ruleEl) setTimeout(function () { ruleEl.classList.add('is-vis'); }, 620);
    setTimeout(function () { subEl.classList.add('is-vis');        }, 620);
    setTimeout(function () { choicesEl.classList.add('is-vis');    }, 1220);
    setTimeout(function () { hintEl.classList.add('is-vis');       }, 1640);
    /* Set the flag after the longest fade completes, so a user who
       interrupts (clicks EXPERIENCE before animations finish) still
       gets the skip on their next return. */
    setTimeout(function () {
      try { sessionStorage.setItem('bios_portal_animated', '1'); } catch (_) {}
    }, 1700);
  }

  /* ── Wordmark: typewriter reveal then occasional glitch ── */
  var _asciiNameEl = document.getElementById('bios-portal-ascii-name');
  if (_asciiNameEl) {
    var _WORDMARK_TEXT = 'innocences';
    var _GLITCH_SET    = '01#@░▒▓█&%?!▄▀ア'.split('');
    var _ASCII_ORIG    = '';

    function _glitchAsciiName() {
      if (!_ASCII_ORIG) return;
      var chars = _ASCII_ORIG.split('');
      var hits  = 3 + Math.floor(Math.random() * 7);
      for (var _gi = 0; _gi < hits; _gi++) {
        var _idx = Math.floor(Math.random() * chars.length);
        if (chars[_idx] !== '\n' && chars[_idx] !== ' ') {
          chars[_idx] = _GLITCH_SET[Math.floor(Math.random() * _GLITCH_SET.length)];
        }
      }
      _asciiNameEl.textContent = chars.join('');
      setTimeout(function() {
        if (_asciiNameEl) _asciiNameEl.textContent = _ASCII_ORIG;
        _scheduleAsciiGlitch();
      }, 70 + Math.random() * 110);
    }
    function _scheduleAsciiGlitch() {
      setTimeout(_glitchAsciiName, 2200 + Math.random() * 4000);
    }

    /* Type out the wordmark character by character */
    function _typeWordmark() {
      _asciiNameEl.textContent = '';
      var cursor = document.createElement('span');
      cursor.className = 'bios-portal-typing-cursor';
      cursor.setAttribute('aria-hidden', 'true');
      _asciiNameEl.appendChild(cursor);
      var i = 0;
      function _nextChar() {
        if (i < _WORDMARK_TEXT.length) {
          _asciiNameEl.insertBefore(document.createTextNode(_WORDMARK_TEXT[i]), cursor);
          i++;
          setTimeout(_nextChar, 65 + Math.random() * 55);
        } else {
          /* Typing done — hold cursor briefly, then remove it and start glitch */
          setTimeout(function() {
            if (cursor.parentNode) cursor.parentNode.removeChild(cursor);
            _ASCII_ORIG = _asciiNameEl.textContent;
            _scheduleAsciiGlitch();
          }, 480);
        }
      }
      _nextChar();
    }

    if (_portalAlreadyAnimated) {
      /* Session-return shortcut — render the wordmark fully resolved
         (no typing animation) and immediately schedule the ambient
         glitch so the brand still flickers occasionally. */
      _asciiNameEl.textContent = _WORDMARK_TEXT;
      _ASCII_ORIG = _WORDMARK_TEXT;
      _scheduleAsciiGlitch();
    } else {
      /* First visit — full typewriter reveal at +130ms (matches portal
         fade-in at 120ms). */
      setTimeout(_typeWordmark, 130);
    }
  }

  /* ── Wordmark-width sync for the nav row ──────────────────────────
     The nav buttons should sit directly under the "innocences" wordmark
     with the row spanning exactly the wordmark's width — not wider, not
     narrower. We measure the wordmark and write the width to a CSS
     variable on the choices container; the container's
     justify-content: space-between then spreads the items across that
     exact width.

     Sync timing:
       • run once on next frame in case wordmark text is already present
       • run again ~1500ms after page load (after typewriter completes)
       • observe viewport resize so the width stays accurate */
  (function syncPortalNavWidth() {
    var wordmark = document.getElementById('bios-portal-ascii-name');
    var choices  = document.getElementById('bios-portal-choices');
    if (!wordmark || !choices) return;

    function applyWidth() {
      var w = wordmark.getBoundingClientRect().width;
      /* Guard: if the wordmark hasn't rendered yet, skip and re-poll. */
      if (w < 20) return;
      choices.style.setProperty('--portal-nav-width', w + 'px');
    }

    /* First attempt next frame in case the wordmark is already laid out
       (returning visitors, cached DOM, etc.) */
    requestAnimationFrame(applyWidth);
    /* Polling fallback for the typewriter: the wordmark width grows as
       characters get typed; capture the final width after ~1500ms (10
       chars × ~100ms typing + cursor hold). */
    setTimeout(applyWidth, 1500);
    /* Re-measure on viewport changes — wordmark uses clamp() font-size
       so its actual rendered width depends on viewport width. */
    window.addEventListener('resize', function () {
      /* Debounce: rAF coalesces multiple resize events to one measure. */
      requestAnimationFrame(applyWidth);
    });
  })();

  /* ── Portal binary drip canvas ── */
  (function() {
    function initDrip() {
      var pre    = document.getElementById('bios-portal-ascii-name');
      var canvas = document.getElementById('bios-portal-drip-canvas');
      if (!pre || !canvas) return;
      var ctx = canvas.getContext('2d');
      var drips = [];
      var cw = 0, ch = 0, cssW = 0, cssH = 0, validCols = [], FONT = '';

      function measure() {
        var cs = window.getComputedStyle(pre);
        var m = document.createElement('span');
        m.style.cssText = 'position:fixed;top:-9999px;left:-9999px;visibility:hidden;white-space:pre;letter-spacing:0;';
        m.style.fontFamily = cs.fontFamily;
        m.style.fontSize   = cs.fontSize;
        m.style.lineHeight = cs.lineHeight;
        m.textContent = 'MMMMMMMMMM';
        document.body.appendChild(m);
        cw = m.offsetWidth / 10;
        m.textContent = 'M\nM';
        var h2 = m.offsetHeight;
        m.textContent = 'M';
        var h1 = m.offsetHeight;
        ch = h2 - h1;
        if (ch <= 0) ch = h1 || 9;
        FONT = cs.fontSize + ' ' + cs.fontFamily;
        document.body.removeChild(m);
      }

      var validInnerCols = []; /* columns with chars in top half — for through-letter drips */

      function setup() {
        measure();
        var lines = pre.textContent.split('\n');
        var maxC = 0;
        for (var i = 0; i < lines.length; i++) maxC = Math.max(maxC, lines[i].length);
        var bottomRow = [], topRow = [];
        for (var c = 0; c < maxC; c++) { bottomRow[c] = -1; topRow[c] = lines.length; }
        for (var r = 0; r < lines.length; r++) {
          for (var c = 0; c < lines[r].length; c++) {
            if (lines[r][c] !== ' ') {
              if (r < topRow[c]) topRow[c] = r;
              bottomRow[c] = r;
            }
          }
        }
        var midRow = Math.floor(lines.length * 0.3);
        validCols = [];
        validInnerCols = [];
        for (var c = 0; c < maxC; c++) {
          if (bottomRow[c] >= midRow) validCols.push({ col: c, row: bottomRow[c] });
          if (topRow[c] < lines.length) validInnerCols.push({ col: c, topRow: topRow[c], bottomRow: bottomRow[c] });
        }
        var pr = pre.getBoundingClientRect();
        var dpr = window.devicePixelRatio || 1;
        cssW = pr.width;
        cssH = pr.height + (window.innerWidth < 600 ? 100 : 160);
        canvas.width  = Math.round(cssW * dpr);
        canvas.height = Math.round(cssH * dpr);
        canvas.style.width  = cssW + 'px';
        canvas.style.height = cssH + 'px';
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.scale(dpr, dpr);
        drips = [];
      }

      function makeRowChars(n) {
        var a = [];
        for (var i = 0; i < n + 2; i++) a.push(Math.random() < 0.5 ? '1' : '0');
        return a;
      }

      /* outer drip — starts at bottom edge of a letter column, falls into void */
      function spawnOuterDrip() {
        if (!validCols.length) return;
        var vc = validCols[Math.floor(Math.random() * validCols.length)];
        var trailLen = 6 + Math.floor(Math.random() * 14);
        drips.push({
          col: vc.col, startRow: vc.row + 1, head: 0,
          speed: 0.05 + Math.random() * 0.10,
          trailLen: trailLen, rowChars: makeRowChars(trailLen),
          tick: 0, inner: false
        });
      }

      /* inner drip — starts at the top of a letter column, drips THROUGH the ASCII */
      function spawnInnerDrip() {
        if (!validInnerCols.length) return;
        var vc = validInnerCols[Math.floor(Math.random() * validInnerCols.length)];
        var trailLen = 3 + Math.floor(Math.random() * 6);
        /* start somewhere within the letter height */
        var startRow = vc.topRow + Math.floor(Math.random() * Math.max(1, vc.bottomRow - vc.topRow + 1));
        drips.push({
          col: vc.col, startRow: startRow, head: 0,
          speed: 0.04 + Math.random() * 0.07,
          trailLen: trailLen, rowChars: makeRowChars(trailLen),
          tick: 0, inner: true,
          endRow: vc.bottomRow + 1 + Math.floor(Math.random() * 4) /* drip a little past letter bottom */
        });
      }

      var lastSpawn = 0, nextInt = 200;
      var lastInner = 0, nextInner = 350;
      function draw(ts) {
        requestAnimationFrame(draw);
        ctx.clearRect(0, 0, cssW, cssH);
        ctx.font = FONT;
        ctx.textBaseline = 'top';

        /* spawn outer drips */
        if (ts - lastSpawn > nextInt && drips.filter(function(d){ return !d.inner; }).length < 22) {
          spawnOuterDrip();
          lastSpawn = ts;
          nextInt = 120 + Math.random() * 380;
        }
        /* spawn inner drips */
        if (ts - lastInner > nextInner && drips.filter(function(d){ return d.inner; }).length < 10) {
          spawnInnerDrip();
          lastInner = ts;
          nextInner = 200 + Math.random() * 500;
        }

        drips = drips.filter(function(d) {
          d.head += d.speed;
          d.tick += 1;
          var headInt = Math.floor(d.head);

          /* occasional char flicker */
          if (d.tick % 6 === 0) {
            var flip = Math.floor(Math.random() * d.rowChars.length);
            d.rowChars[flip] = Math.random() < 0.5 ? '1' : '0';
          }

          var alphaScale = d.inner ? 0.42 : 1.0; /* inner drips more ghostly */

          for (var i = 0; i <= Math.min(headInt, d.trailLen - 1); i++) {
            var absRow = d.startRow + headInt - i;
            var py = absRow * ch;
            if (py < 0 || py > cssH) continue;
            var frac = 1 - (i / d.trailLen);
            var ch_char = d.rowChars[i] || '0';
            if (i === 0) {
              ctx.fillStyle = 'rgba(255,255,255,' + (frac * alphaScale).toFixed(2) + ')';
            } else {
              ctx.fillStyle = 'rgba(210,210,210,' + (frac * 0.52 * alphaScale).toFixed(2) + ')';
            }
            ctx.fillText(ch_char, d.col * cw, py);
          }

          /* kill inner drips when they've passed their target row */
          if (d.inner && d.endRow !== undefined) {
            return (d.startRow + headInt) <= d.endRow + d.trailLen;
          }
          return (d.startRow + headInt - d.trailLen) * ch < cssH + ch;
        });
      }

      setTimeout(function() {
        setup();
        requestAnimationFrame(draw);
        window.addEventListener('resize', function() {
          ctx.setTransform(1, 0, 0, 1, 0, 0);
          setup();
        });
      }, 150);
    }
    initDrip();
  })();

  /* ── Hover → type description (desktop) / tap → type description (touch) ── */
  var biosTyped  = false;
  var storeTyped = false;

  /* ── Char-corruption glitch on hover (applies to ALL nav items) ──
     Generalized from the EXPERIENCE-only version: every nav button or
     link with a `.bios-portal-choice-label` child gets its inner text
     scrambled with glitch chars while hovered, restored on leave. Each
     element runs its own setInterval so they corrupt independently. */
  var _GLITCH_CHARS = '█▓░▒01'.split('');

  function setupNavCorruption(el) {
    if (!el) return;
    var label = el.querySelector('.bios-portal-choice-label');
    if (!label) return;
    var orig    = label.textContent;
    var ticker  = null;

    function start() {
      if (ticker) return;
      label.classList.add('is-corrupt');
      function tick() {
        var chars = orig.split('');
        var count = Math.random() < 0.5 ? 2 : 1;
        for (var ci = 0; ci < count; ci++) {
          var pos = Math.floor(Math.random() * chars.length);
          if (chars[pos] !== ' ') {
            chars[pos] = _GLITCH_CHARS[Math.floor(Math.random() * _GLITCH_CHARS.length)];
          }
        }
        label.textContent = chars.join('');
        ticker = setTimeout(tick, 80 + Math.floor(Math.random() * 60));
      }
      tick();
    }
    function stop() {
      clearTimeout(ticker);
      ticker = null;
      label.classList.remove('is-corrupt');
      label.textContent = orig;
    }

    el.addEventListener('mouseenter', start);
    el.addEventListener('mouseleave', stop);
    if (portalIsTouch) {
      el.addEventListener('touchstart', start, { passive: true });
    }
  }

  /* Attach to every portal nav item (EXPERIENCE, STORE, BLOG, FAQ, INFO). */
  var _navItems = portalEl.querySelectorAll('.bios-portal-nav-btn, .bios-portal-nav-link');
  for (var _ni = 0; _ni < _navItems.length; _ni++) {
    setupNavCorruption(_navItems[_ni]);
  }

  biosEl.addEventListener('mouseenter', function () {
    BiosAudio.portalTone('bios');
    if (biosTyped) return; biosTyped = true;
    typeLines(biosDesc, BIOS_LINES, 22);
  });
  /* STORE button removed from the portal markup. All storeEl handlers
     null-guarded so a missing element doesn't crash portal init. The
     `choose('store')` branch in choose() is kept so external callers
     (e.g. routes outside the portal nav) can still trigger the /pages/store
     navigation if needed. */
  if (storeEl) {
    storeEl.addEventListener('mouseenter', function () {
      BiosAudio.portalTone('store');
      if (storeTyped) return; storeTyped = true;
      typeLines(storeDesc, STORE_LINES, 22);
    });
  }

  /* On touch: type description on first tap (before choose fires) */
  if (portalIsTouch) {
    biosEl.addEventListener('touchstart', function () {
      if (!biosTyped) { biosTyped = true; typeLines(biosDesc, BIOS_LINES, 14); }
    }, { passive: true });
    if (storeEl) {
      storeEl.addEventListener('touchstart', function () {
        if (!storeTyped) { storeTyped = true; typeLines(storeDesc, STORE_LINES, 14); }
      }, { passive: true });
    }
  }

  /* ── Click → choose ── */
  function choose(choice) {
    sessionStorage.setItem('bios_portal_choice', choice);
    sessionStorage.setItem('bios_choice', choice);
    /* Fire the signature PORTAL-ENTER cue at the exact moment the
       experience is selected. Uses the BiosAudio sample-bridge: if
       sfx-portal-enter.mp3 is deployed it plays the ElevenLabs cue,
       otherwise falls back to the checkoutConnect modem handshake
       synth. Wrapped in try/catch so a missing audio context never
       blocks navigation. */
    try { if (window.BiosAudio) window.BiosAudio.portalEnter(); } catch (_) {}
    /* Ring-loading SFX — also fire HERE (inside the user-gesture click
       handler) in addition to the play attempt inside applyCatalogOrbit.
       Reason: applyCatalogOrbit gets invoked via the bios:portal-done
       event listener which may lose the user-gesture context by the
       time it runs (event dispatch can break the activation chain in
       some browsers). Calling play() here from the direct click handler
       guarantees a fresh gesture context for the autoplay-policy gate.
       The applyCatalogOrbit attempt still runs as fallback. */
    if (choice === 'bios') {
      try {
        var _ringEnter = new Audio('https://cdn.shopify.com/s/files/1/0762/5726/3866/files/undo.wav?v=1779655474');
        _ringEnter.volume = 0.30;
        var _rep = _ringEnter.play();
        if (_rep && typeof _rep.catch === 'function') _rep.catch(function () {});
      } catch (_) {}
    }
    if (choice === 'store') {
      window.location.href = '/pages/store';
      return;
    }

    /* Apply catalog-orbit-mode SYNCHRONOUSLY before any portal-done
       dispatch — but ONLY on desktop. Mobile bails out of orbit-mode
       (setupCatalogOrbit returns early on touch) and applying the
       class there hides every product via the
       .bios-item:not(.is-batch-item){display:none} rule. */
    var _isTouch = navigator.maxTouchPoints > 0 ||
                   (window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches);
    var _drum = document.getElementById('bios-drum');
    if (!_isTouch && _drum && !_drum.classList.contains('is-designer-mode')) {
      _drum.classList.add('is-catalog-orbit-mode');
    }

    /* Instant portal hide — the synchronous orbit-mode class above
       guarantees the catalog underneath is already orbit-styled, so
       there's no flash of the default layout. (Previous attempt to
       layer biosPageGlitch on top of this caused a grey screen
       because that overlay's animation ends at opacity:1 and was
       designed to be followed by a navigation. Without a navigation,
       the overlay stayed up.) */
    portalEl.style.display = 'none';
    var _root = document.getElementById('bios-root');
    if (_root) _root.classList.remove('is-pre-choice');
    document.dispatchEvent(new CustomEvent('bios:portal-done'));
    document.dispatchEvent(new CustomEvent('bios:portal-dismissed', { detail: { choice: choice } }));
  }

  biosEl.addEventListener('click',  function () { choose('bios');  });
  biosEl.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose('bios'); }
  });
  if (storeEl) {
    storeEl.addEventListener('click', function () { choose('store'); });
    storeEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose('store'); }
    });
  }
})();

/* Onboarding overlay removed — load choreography supplies the in-place tutorial. */

/* ── Portal ambient background: dust + faint nodes ───────────────────────── */
(function () {
  var canvas = document.getElementById('bios-portal-bg-canvas');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  var W = 0, H = 0;
  var nodes = [], dust = [];
  /* Bumped from 32 / 90 → 60 / 240. The lower counts were too sparse
     on wide viewports — at 1920×1080 you got ~1 dust particle per
     23,000 pixels, so random clustering left whole regions of the
     screen visually empty (most-noticeable on the right half where
     the 3D scan's negative space is). 240 dust gets to ~1 per 8,600
     pixels, dense enough that the eye reads continuous atmosphere
     instead of localized clusters. Still cheap to draw — 60Hz cost
     is dominated by the O(n²) node connect loop, not the dust. */
  var NODE_COUNT  = 60;
  var DUST_COUNT  = 240;
  var CONNECT_MAX = 180; /* px — max distance for a connecting line */

  function resize() {
    var dpr = window.devicePixelRatio || 1;
    W = window.innerWidth;
    H = window.innerHeight;
    canvas.width  = Math.round(W * dpr);
    canvas.height = Math.round(H * dpr);
    canvas.style.width  = W + 'px';
    canvas.style.height = H + 'px';
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.scale(dpr, dpr);
  }

  function makeNode() {
    return {
      x:  Math.random() * W,
      y:  Math.random() * H,
      vx: (Math.random() - 0.5) * 0.14,
      vy: (Math.random() - 0.5) * 0.14,
      r:  0.9 + Math.random() * 1.2
    };
  }

  function makeDust() {
    return {
      x:  Math.random() * W,
      y:  H + Math.random() * H,   /* start below — float up */
      vx: (Math.random() - 0.5) * 0.3,
      vy: -(0.12 + Math.random() * 0.28),
      r:  0.4 + Math.random() * 1.1,
      /* Bumped opacity range from 0.04–0.17 → 0.07–0.24. Higher floor
         so the sparsest dots still register; slightly higher ceiling
         so the brightest read as actual "specks" rather than noise. */
      a:  0.07 + Math.random() * 0.17
    };
  }

  /* Re-spread all existing particles across the current W × H. Used
     after init (in case W/H were stale or zero at first call) and
     whenever the viewport grows dramatically (covers the "particles
     stuck at 0,0" case described below). Safe to call repeatedly. */
  function spreadParticles() {
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].x = Math.random() * W;
      nodes[i].y = Math.random() * H;
    }
    for (var j = 0; j < dust.length; j++) {
      dust[j].x = Math.random() * W;
      dust[j].y = Math.random() * H;
    }
  }

  function init() {
    resize();
    nodes = []; dust = [];
    for (var i = 0; i < NODE_COUNT; i++) nodes.push(makeNode());
    for (var i = 0; i < DUST_COUNT;  i++) {
      var d = makeDust();
      d.y = Math.random() * H; /* spread initial dust across screen */
      dust.push(d);
    }
    /* If init() ran with a zero/tiny viewport (Safari background tab,
       pre-paint, splash-covered layout state, etc.) every particle is
       sitting at Math.random()*0 = 0 — clustered in the top-left
       corner. We can't reliably detect that here, so the defensive
       fixes below (deferred re-spread + dramatic-resize re-spread)
       catch it after the fact. */
  }

  var _raf = null;
  var _running = true;

  function draw() {
    if (!_running) return;
    _raf = requestAnimationFrame(draw);
    ctx.clearRect(0, 0, W, H);

    /* ── nodes ── */
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      n.x += n.vx; n.y += n.vy;
      /* wrap edges */
      if (n.x < 0) n.x = W; else if (n.x > W) n.x = 0;
      if (n.y < 0) n.y = H; else if (n.y > H) n.y = 0;
      /* draw node dot */
      ctx.beginPath();
      ctx.arc(n.x, n.y, n.r, 0, 6.2832);
      ctx.fillStyle = 'rgba(190,185,170,0.14)';
      ctx.fill();
    }

    /* ── connecting lines ── */
    ctx.lineWidth = 0.4;
    for (var i = 0; i < nodes.length; i++) {
      for (var j = i + 1; j < nodes.length; j++) {
        var dx = nodes[i].x - nodes[j].x;
        var dy = nodes[i].y - nodes[j].y;
        var dist = Math.sqrt(dx * dx + dy * dy);
        if (dist < CONNECT_MAX) {
          var alpha = (1 - dist / CONNECT_MAX) * 0.055;
          ctx.beginPath();
          ctx.moveTo(nodes[i].x, nodes[i].y);
          ctx.lineTo(nodes[j].x, nodes[j].y);
          ctx.strokeStyle = 'rgba(190,185,170,' + alpha.toFixed(4) + ')';
          ctx.stroke();
        }
      }
    }

    /* ── dust ── */
    for (var i = 0; i < dust.length; i++) {
      var d = dust[i];
      d.x += d.vx; d.y += d.vy;
      /* recycle when off top */
      if (d.y < -4) { d.y = H + 4; d.x = Math.random() * W; }
      if (d.x < -4) d.x = W + 4;
      else if (d.x > W + 4) d.x = -4;
      ctx.beginPath();
      ctx.arc(d.x, d.y, d.r, 0, 6.2832);
      ctx.fillStyle = 'rgba(210,205,190,' + d.a.toFixed(4) + ')';
      ctx.fill();
    }
  }

  init();
  draw();

  /* Defensive deferred re-spread — catches the "all particles at 0,0"
     case where init() ran while window.innerWidth/Height was 0 or
     stale. Fires twice (at ~250ms and ~1200ms after script load) so
     even if the BIOS splash dismiss timing varies, at least one runs
     after the viewport has settled to its final dimensions. Idempotent —
     re-spreading particles that are already well-distributed just
     re-shuffles them, no harm done. */
  setTimeout(function () {
    if (W > 0 && H > 0 && dust.length > 0) spreadParticles();
  }, 250);
  setTimeout(function () {
    if (W > 0 && H > 0 && dust.length > 0) spreadParticles();
  }, 1200);
  /* Also re-spread the moment window.load fires — by then all sub-
     resources (CSS, images, fonts) have settled and the viewport
     dimensions are guaranteed final. */
  if (document.readyState !== 'complete') {
    window.addEventListener('load', function () {
      if (W > 0 && H > 0 && dust.length > 0) spreadParticles();
    });
  }

  window.addEventListener('resize', function () {
    var prevW = W, prevH = H;
    resize();
    /* If the viewport grew dramatically (e.g., from 0/tiny to real
       size, or orientation flip portrait→landscape), every existing
       particle is now wedged on the small side. Full re-spread covers
       the whole new area instantly instead of waiting for natural
       recycling to repopulate the new region. */
    if (W > prevW * 1.5 || H > prevH * 1.5 || prevW < 100 || prevH < 100) {
      spreadParticles();
      return;
    }
    /* Normal small resize: just clamp out-of-bounds particles. */
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].x > W) nodes[i].x = Math.random() * W;
      if (nodes[i].y > H) nodes[i].y = Math.random() * H;
    }
    for (var j = 0; j < dust.length; j++) {
      if (dust[j].x > W + 4) dust[j].x = Math.random() * W;
      if (dust[j].y > H + 4) dust[j].y = Math.random() * H;
    }
  });

  /* Stop animating once the portal is gone to free GPU */
  document.addEventListener('bios:portal-done', function () {
    _running = false;
    if (_raf) cancelAnimationFrame(_raf);
  });
})();


/* ── Ambient nav flicker ──────────────────────────────────────────────────
   Pick a random [SHOP] / [BLOG] / [FAQ] / [INFO] item every 1-3 seconds
   and add .is-flickering for the keyframe's duration (~240ms). Makes the
   four portal entry points feel like an unstable CRT instead of a static
   stencil. Stops once the portal is dismissed so it doesn't burn cycles
   when the user is inside the catalog. */
(function biosNavFlicker() {
  'use strict';

  var navItems = document.querySelectorAll('.bios-portal-nav-btn, .bios-portal-nav-link');
  if (!navItems.length) return;

  /* Respect prefers-reduced-motion. */
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var stopped = false;
  document.addEventListener('bios:portal-done', function () { stopped = true; });

  function tick() {
    if (stopped) return;
    var pick = navItems[Math.floor(Math.random() * navItems.length)];
    /* Don't flicker the currently-hovered or active item — would fight
       the hover glow and read as a bug. */
    if (!pick.matches(':hover') && !pick.classList.contains('is-active')) {
      pick.classList.add('is-flickering');
      setTimeout(function () { pick.classList.remove('is-flickering'); }, 260);
    }
    /* Next flicker: 900-3000ms gap. Occasional double-fire for clusters. */
    var gap = 900 + Math.random() * 2100;
    if (Math.random() < 0.18) gap = 180 + Math.random() * 220; /* burst */
    setTimeout(tick, gap);
  }

  /* Hold off the first flicker until the portal reveal has settled. */
  setTimeout(tick, 1800);
})();
